import { render, staticRenderFns } from "./SMSIcon.vue?vue&type=template&id=270bf198&scoped=true"
import script from "./SMSIcon.vue?vue&type=script&lang=js"
export * from "./SMSIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bf198",
  null
  
)

export default component.exports